module.exports = __webpack_public_path__ + "img/thumbnail_Koala_f_normal.b4ee67ff.png";